import React from 'react';
import * as _ from 'lodash';
import PropTypes from 'prop-types';
import { withTranslation } from "react-i18next";

class FilterableMultiSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.items,
      filteredItems: [],
      filterBy: props.filterBy,
      query: '',
      showDropDown: false,
      selectedItems: []
    };
  }

  componentDidMount() {
    const { input: { value } } = this.props;
    const { items } = this.state;

    const preSelected = items.filter(
      item => value.indexOf(item.id) > -1
    );

    this.setState({
      filteredItems: items,
      selectedItems: preSelected || []
    });
  }

  componentDidUpdate(prevProps) {
    if(this.props.items !== prevProps.items) {
        this.setState({
            items: this.props.items,
            filteredItems: this.props.items
        })
    }
  }

  filterList = (query, t) => {
    const { items, filterBy } = this.state;
    if (query.length === 0) {
      this.setState({
        filteredItems: items,
        query
      });
    } else {
      const l = items.filter(item => filterBy.some(key => (
        _.get(item, key, '')
          .toLowerCase()
          .indexOf(query.toLowerCase()) > -1
      )));
      if (l.length === 0) l.push({ id: -1, name: t('noFilterResultMessage') });
      this.setState({
        filteredItems: l,
        query
      });
    }
  };

  toggleDropDown = (show) => {
    this.setState({
      showDropDown: show
    });
  };

  onChange = () => {
    const {
      input: { onChange }
    } = this.props;
    const { items, selectedItems } = this.state;
    if (onChange) {
      onChange(selectedItems);
      this.setState({
        filteredItems: items
      });
    } else {
      console.log('ON CHANGE IS NULL');
    }
  }

  setValue = (selectedItem) => {
    if (selectedItem.id === -1) return;

    const { selectedItems, items } = this.state;
    selectedItems.push(selectedItem);
    this.setState({
      selectedItems,
      items: items.filter(item => item.id !== selectedItem.id),
      query: ''
    }, () => this.onChange());
  };

  removeItem = (item) => {
    const { selectedItems, items } = this.state;
    selectedItems.splice(selectedItems.indexOf(item), 1);
    items.push(item);
    this.setState({
      selectedItems,
      items,
      query: ''
    }, () => this.onChange());
  }

  onBackSpace = (e) => {
    const { query, selectedItems } = this.state;
    if (query.length === 0 && selectedItems.length >= 1 && e.keyCode === 8) {
      this.removeItem(selectedItems[selectedItems.length - 1]);
    }
  }

  render() {
    const {
      filteredItems, showDropDown, query, selectedItems
    } = this.state;
    const { placeholder, extraKey, t } = this.props;

    return (
      <div className="filterable-multiselect">
        <div className="input-wrapper">
          {selectedItems.map(item => (
            <div className="item" key={item.id}>
              {item.name}
              <span className="remove" onClick={() => this.removeItem(item)}>&nbsp;&times;&nbsp;</span>
            </div>
          ))}
          <input
            className="input"
            type="text"
            placeholder={placeholder}
            onInput={e => this.filterList(e.target.value, t)}
            onChange={e => this.filterList(e.target.value, t)}
            onFocus={() => this.toggleDropDown(true)}
            onBlur={() => this.toggleDropDown(false)}
            onKeyDown={this.onBackSpace}
            value={query}
          />
        </div>
        {showDropDown && (
          <ul className="dropdown">
            {filteredItems.map(item => (
              <li key={item.id} className="item" onMouseDown={() => this.setValue(item)}>
                <p className="text-main">{item.name}</p>
                {extraKey && (
                <p className="text-sub">
                  {item[extraKey]}
                </p>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}

FilterableMultiSelect.propTypes = {
  items: PropTypes.instanceOf(Array).isRequired,
  filterBy: PropTypes.instanceOf(Array).isRequired,
  placeholder: PropTypes.string,
  extraKey: PropTypes.string,
  input: PropTypes.shape({
    value: PropTypes.arrayOf(String),
    onChange: PropTypes.instanceOf(Function)
  })
};

export default withTranslation(["common"])(FilterableMultiSelect);